export const SET_PAGE_TITLE = 'mainpage/set_page_title' as const;

export const setPageTitle = (payload: string) => ({
  type: SET_PAGE_TITLE,
  payload,
});

export type TSetPageTitleAction = ReturnType<typeof setPageTitle>;
